import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Models
import { FromTextboxNumber } from './form-textbox-number';


@Component({
  selector: 'lib-textbox-number',
  templateUrl: './textbox-number.component.html',
  styleUrls: ['./textbox-number.component.scss']
})
export class TextboxNumberComponent implements OnInit {
  @Input() field: FromTextboxNumber;
  @Input() form: FormGroup;

  @Input() valid: boolean;
  @Input() invalid: boolean;

  @Input() min: number;
  @Input() max: number;

  constructor() { }

  ngOnInit(): void {
    if (this.min > 0){
      this.form.get(this.field.key).setValue(this.min);
    } else {
      this.form.get(this.field.key).setValue(0);
    }
  }
}
